"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var warning_prompt_1 = require("../../../../components/pricing/layout/warning-prompt/warning-prompt");

var static_text_1 = require("../../../../components/pricing/text/static-text/static-text");

var constants_1 = require("../../../../theming/pricing-system/constants");

var confirmationWidth = 24;
var confirmationViewStyle = {
  left: "calc(50% - " + confirmationWidth / 2 + "rem)",
  position: 'absolute',
  top: '6rem',
  width: confirmationWidth + "rem"
};
var confirmationStaticTextStyle = {
  fontSize: '1.2rem',
  marginBottom: '1em'
};

exports.PasswordGenerateWarningPrompt = function (props) {
  var buttons = [{
    onPress: props.onConfirmed,
    text: constants_1.PasswordGenerateWarningPromptContent.resetPasswordButtonText
  }, {
    onPress: props.onCanceled,
    text: constants_1.PasswordGenerateWarningPromptContent.cancelButtonText,
    type: 'close'
  }];
  return react_1.default.createElement(warning_prompt_1.WarningPrompt, {
    buttons: buttons,
    viewStyle: confirmationViewStyle
  }, react_1.default.createElement(static_text_1.StaticText, {
    text: constants_1.PasswordGenerateWarningPromptContent.paragraph1,
    textStyle: confirmationStaticTextStyle
  }), react_1.default.createElement(static_text_1.StaticText, {
    text: constants_1.PasswordGenerateWarningPromptContent.paragraph2,
    textStyle: confirmationStaticTextStyle
  }));
};